import { AsyncResp, BaseReq, requestApi } from './fetch-api';

interface GetConfigReq extends BaseReq {}

export async function getGeo(req: GetConfigReq): AsyncResp<null> {
  const { signal } = req;

  const resp = await requestApi<null>({
    signal,
    method: 'GET',
    url: `/geo`,
  });

  return resp;
}
